import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

import { Container } from "./PageNotFound.styles";

function PageNotFound() {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate("/");
  };

  return (
    <Container>
      <Result
        status="404"
        title="404"
        subTitle="Aradığınız sayfa bulunamamaktadır."
        extra={<Button type="primary" onClick={handleOnClick}>Anasayfaya dön</Button>}
      />
    </Container>
  );
}

export default PageNotFound;
